import { ContentIntro } from './content/intro';
import { InternHeadline } from './intern/headline';
import { InternServiceLink } from './intern/service-link';

/**
 * Model definition for category-link-list
 */
export interface CategoryLinkList {
  __contentType: 'category-link-list';
  id: string;
  name?: string;
  intro?: ContentIntro;

  leftHeadline?: InternHeadline;
  left: InternServiceLink[];

  middleHeadline?: InternHeadline;
  middle: InternServiceLink[];

  rightHeadline?: InternHeadline;
  right: InternServiceLink[];
}

export function isCategoryLinkList(obj: { __contentType?: string }): obj is CategoryLinkList {
  return obj.__contentType === 'category-link-list';
}
